export const splunkRUM = {
  SPLUNK_RUM_AUTH: import.meta.env.VITE_SPLUNK_RUM_AUTH as string,
  SPLUNK_BEACON_URL: 'https://rum-ingest.us1.signalfx.com/v1/rum',
  SPLUNK_APP_NAME: 'TravelSchedulerWeb',
};

export const constants = {
  TRAVEL_HOME_PAGE_URL: 'https://www.ace.aaa.com/travel',
  DRIVING_DIRECTIONS_URL:
    'https://www.ace.aaa.com/travel/plan-a-road-trip/maps-and-directions.html#triptiks',
  PASSPORT_PHOTOS_URL:
    'https://www.ace.aaa.com/travel/information/passport-information-and-services.html',
  DRIVING_PERMITS_URL:
    'https://www.ace.aaa.com/travel/information/international-driving-permit.html',
  FOREIGN_CURRENCY_URL: 'https://www.ace.aaa.com/financial/vacation-money.html',
  MEXICO_AUTO_INSURANCE_URL:
    'https://www.ace.aaa.com/travel/travel-services/mexico-insurance.html',
  NOTARY_SERVICES_URL:
    'https://www.ace.aaa.com/membership/member-services/branch-services.html#notary',
  PRIVACY_NOTICE_URL: 'https://www.ace.aaa.com/legal/privacy.html',
  TERMS_AND_CONDITIONS_URL: 'https://www.ace.aaa.com/legal/terms-of-use.html',
  TEXT_TERMS_URL:
    'https://www.ace.aaa.com/legal/text-messaging-programs-terms-and-conditions.html',
  APP_BASE_URL: '/travel/agent/scheduler',
  RELEVANCE_SEARCH_BG_VIDEO_URL:
    '/travel/agent/scheduler/relevanceSearchBgVideo.mp4',
  TANSTACK_ABORTED_ERROR: 'Request aborted',
  DEFAULT_WHEN_DO_YOU_PLAN_TO_TRAVEL: '0-3 Months',
  UTAG_SCRIPT_SRC: 'https://tms.ace.aaa.com/ace/prod/utag.js',
  GOOGLE_MAPS_API_KEY: 'AIzaSyC9zkRDsdYJNhZSRFyb0H5siJBFRTougTA',
};
